import React, { useContext, useEffect, useState } from 'react';
import { auth } from '../utils/init-firebase';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  onAuthStateChanged,
  signOut,
  sendPasswordResetEmail,
  confirmPasswordReset,
  updateProfile,
  updatePassword,
  EmailAuthProvider,
  reauthenticateWithCredential,
  sendEmailVerification,
} from 'firebase/auth';
import { upload_url, default_profile_image } from '../utils/constants';
import axios from 'axios';

const UserContext = React.createContext();

export const UserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);

  const registerUser = async (phoneNumber, name) => {
    try {
      const options = {
        username: name,
        phoneNumber,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_HOST}/api/user/register`,
        options
      );

      const data = response?.data;

      if (data?.success) {
         updateProfile(data?.data, {
           displayName: name,
         });
         localStorage.setItem('currentUser', JSON.stringify(data.data));
        return {
          success: true,
          message: 'Registration successful',
          user: data.data,
        };
      } else {
        return {
          success: false,
          message: data.message || 'Registration failed',
        };
      }
    } catch (error) {
      console.error('Registration error:', error);
      return {
        success: false,
        message:
          error.response?.data?.message || 'Server error during registration',
      };
    }
  };


  {
    /*const loginUser = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        if (user && user.emailVerified) {
          return user;
        } else {
          throw new Error('Please verify your email before logging in.');
        }
      });
  };*/
  }

    const loginUser = async (phoneNumber, otp) => {
     
         try {
           let options = { phoneNumber, otp };
           const response = await axios.post(
             `${process.env.REACT_APP_BACKEND_HOST}/api/user/login`,
             options
           );

           const data = response.data;

           if (data.success) {
            localStorage.setItem('currentUser', JSON.stringify(data.data));
            setCurrentUser(data.data)
             return {
               success: true,
               message: 'login successful',
               user: data.data,
             };
             
           } else {
             return {
               success: false,
               message: data.message || 'login failed',
             };
           }
         } catch (error) {
           console.error('login error:', error);
           return {
             success: false,
             message:
               error.response?.data?.message ||
               'Server error during login',
           };
         }
    };

  const logoutUser = () => {
    localStorage.removeItem("currentUser")
    return signOut(auth);
  };

  const forgotPassword = (email) => {
    return sendPasswordResetEmail(auth, email, {
      url: 'http://localhost:3000/login',
    });
  };

 const signInWithGoogle = () => {
   const provider = new GoogleAuthProvider();

   return signInWithPopup(auth, provider)
     .then((result) => {
       const user = result.user;
        let options = { email: user.email, otp: 123 };
        axios.post(
          `${process.env.REACT_APP_BACKEND_HOST}/api/user/login`,
          options
        )
        .then((response) => {
          const data = response.data;
          if(data.success){
            localStorage.setItem('currentUser', JSON.stringify(data.data));
            setCurrentUser(data.data)
          }
        })
       return user    
     })
     .catch((error) => console.error(error));
 };


  const resetPassword = (oobCode, newPassword) => {
    return confirmPasswordReset(auth, oobCode, newPassword);
  };

 const updateUserProfileImage = async (imageURL) => {
   try {
     const response = await axios.put(
       `${process.env.REACT_APP_BACKEND_HOST}/api/user/updateProfileImage`,
       {
         email: currentUser.email,
         photoURL: imageURL,
       }
       
     );
     let user = { ...currentUser, photoURL: imageURL };
    localStorage.setItem("currentUser", JSON.stringify(user))
     return response.data;
   } catch (error) {
     const message =
       error.response?.data?.message || 'Error updating profile image';
     return { success: false, message };
   }
 };


  const updateUserProfileName = async (name) => {
    return updateProfile(currentUser, {
      displayName: name,
    });
  };

  

  const updateUserDetails=async(field, value, oldpassword=null, isReset=false, email="")=>{
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_HOST}/api/user/updateProfile`,
        {
          email: isReset ? email: currentUser.email,
          field: field,
          value: value,
          oldpassword:oldpassword, isReset:isReset
        }
      );

      let user = { ...currentUser };
      currentUser[field] = value;
      localStorage.setItem('currentUser', JSON.stringify(currentUser));
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || 'Error updating profile image';
      return { success: false, message };
    }
  }

    const updateProfile = async (
      name, email, phoneNumber
    ) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_BACKEND_HOST}/api/user/updateProfileDetails/${currentUser.id}`,
          {
            email: email,
            name:name,
            phoneNumber:phoneNumber
          }
        );

        let user = { ...currentUser };
        currentUser.email=email; currentUser.username=name; currentUser.phoneNumber=phoneNumber
        localStorage.setItem('currentUser', JSON.stringify(currentUser));
        return response.data;
      } catch (error) {
        const message =
          error.response?.data?.message || 'Error updating profile image';
        return { success: false, message };
      }
    };

  const reauthenticateUser = async (existingPassword) => {
    const credentials = EmailAuthProvider.credential(
      currentUser.email,
      existingPassword
    );
    return reauthenticateWithCredential(currentUser, credentials);
  };

  const updateUserProfilePassword = async (newPassword) => {
    return updatePassword(currentUser, newPassword);
  };

  const uploadProfileImage = async (image) => {
    try {
      const response = await axios.post(upload_url, { image });
      const { success, data } = response.data;
      return { success, data };
    } catch (error) {
      const { success, message } = error.response.data;
      return { success, message };
    }
  };

  const verifyUserPhone=async(phone, login = null)=>{
 try {
  const options={phone:phone, login}
       let response = await axios.post(
         `${process.env.REACT_APP_BACKEND_HOST}/api/user/verify-phone`,
         options
       );
      const { success, data } = response.data;
      return  {success, data};
    } catch (error) {
      const { success, message } = error.response.data;
      return { success, message };
    }
  }
  // useEffect(() => {
  //   const unsubscribe = onAuthStateChanged(auth, (user) => {
  //     if (auth?.currentUser?.emailVerified) {
  //       setCurrentUser(user);
  //     }
  //   });
  //   return () => unsubscribe();
  // }, []);

  useEffect(() => {
    if (!currentUser) {
      return;
    }
    // if (!currentUser.photoURL) {
    //   updateUserProfileImage(default_profile_image)
    //     .then(() => setCurrentUser(currentUser))
    //     .catch(() => console.log('Error occured'));
    // }
    // eslint-disable-next-line
  }, [currentUser]);

  useEffect(() => {
    const storedUser = localStorage.getItem('currentUser');
    if (storedUser) {
      setCurrentUser(JSON.parse(storedUser)); 
    }
  }, []);

  return (
    <UserContext.Provider
      value={{
        currentUser,
        registerUser,
        loginUser,
        logoutUser,
        signInWithGoogle,
        forgotPassword,
        resetPassword,
        updateUserProfileImage,
        updateUserProfileName,
        uploadProfileImage,
        updateUserProfilePassword,
        reauthenticateUser,
        updateUserDetails,
        updateProfile,
        verifyUserPhone,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
// make sure use
export const useUserContext = () => {
  return useContext(UserContext);
};
